<template>
  <a-card :bordered="false">
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="选择批次">
        <selectGoodBatch v-on:select="batchSelect" :checkout="false"></selectGoodBatch>

      </a-tab-pane>
      <a-tab-pane :key="2" tab="选择单号" :disabled="!batchData">
        <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
          <a-form-item label="创建时间" name='time'>
            <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
          </a-form-item>
          <a-form-item label="入库仓库" name='warehouse_id'>
            <a-select v-model:value="search.warehouse_id" :style="{width:'140px'}" placeholder="全部">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="类型" name='create_type'>
            <a-select v-model:value="search.create_type" :style="{width:'140px'}" placeholder="全部">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">快速入库</a-select-option>
              <a-select-option value="2">按单入库</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
            <a-button type="primary" v-has:antiWarehousingExport="exportTable">导出</a-button>
          </a-form-item>
        </a-form>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='warehousing_sn' :columns='columns' class="tableFixBox" :data-source='list' :scroll="{ x: 'max-content'}" :row-selection="rowSelection">
          <template #title_num>
            入库数量
          </template>
          <template #real_code_num>
            实际数量
            <a-tooltip placement='right'>
              <template #title>包装的最小单位数量</template>
              <InfoCircleOutlined />
            </a-tooltip>
          </template>
          <template v-slot:realCodeNum="{ record }">
            <P @click="targetId=record.id;codeDetailVisible=true" style="color:#f04635;cursor: pointer;"> {{record.code_num || '-'}}</P>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />

        <div class="s_flex_center">
          <a-button  class="m-r-10" @click="allBatch">全部批次</a-button>
          <a-button class="m-r-10" @click="someBatch">选中批次</a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="选择需要修改批次" :disabled="!selectedRowKeys">
        <selectGoodBatch v-on:select="editBatchSelect" :checkout="false" :productSkuSn="batchData.product_sku_sn" :productId="batchData.product_id"></selectGoodBatch>
      </a-tab-pane>
    </a-tabs>
  </a-card>

</template>

<script>
import { ref } from "@vue/reactivity";
import useTableSearch from "@/hooks/useTableSearch";
import {
  getWarehousing,
  changeWarehousingBatch
} from "@/api/antiFleeing";
import { message } from 'ant-design-vue';
import { iscode } from '../../../../utils/app';
// 初始化默认筛选项数值
let defSearch = {
  start_time: "",
  end_time: "",
  warehouse_id: "",
  page: 1,
  limit: 10,
  create_type: "",
  keyword_type: "product_batch",
  keyword: "",
  product_id: [],
  product_name: "",
};
let columns = [
  {
    title: "入库单号",
    dataIndex: "warehousing_sn",
    key: "warehousing_sn",
  },
  {
    title: "入库仓库",
    dataIndex: "warehouse_name",
    key: "warehouse_name",
  },
  {
    title: "生产批次",
    dataIndex: "product_batch_name",
    key: "product_batch_name",
    customRender: ({ record }) => {
      return record.product_batch_name ? record.product_batch_name : "-";
    },
  },
  {
    dataIndex: "warehousing_num",
    key: "warehousing_num",
    slots: { title: "title_num" },
  },
  {
    dataIndex: "real_code_num",
    key: "real_code_num",
    slots: { title: "real_code_num", customRender: "realCodeNum" },
  },
  {
    title: "类型",
    dataIndex: "create_type_text",
    key: "create_type_text",
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
  },
];
export default {
  setup(porps,{emit}) {
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    const selectedRowKey=ref(null)
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
          selectedRowKey.value=selectedRowKeys
        console.log(
          `selectedRowKeys: ${selectedRowKeys}`,
          "selectedRows: ",
          selectedRows
        );
      },
      onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
      }
    };
    const batchData = ref({});
    const activeKey = ref(1);
    const batchSelect = (data) => {
      batchData.value = data;
      editBatchData.value = null;
      search.value.keyword = data.batch_name;
      tableHoosks.initData(getWarehousing, search.value);
      activeKey.value = 2;
      selectedRowKey.value=null
    };
    // 选择单号
    const allBatch=()=>{
          selectedRowKey.value='all'  
      activeKey.value = 3;
    }
    //部分单号
    const someBatch=()=>{
        console.log(selectedRowKey.value)
        if(!selectedRowKey.value){
            message.error('请选择单号')
            return
        }
      activeKey.value = 3;
    }
    // 选中的批次
    var editBatchData = ref(null);
    const editBatchSelect = async (data) => {
      console.log(data)
      const json={
        type:selectedRowKey.value=='all'?2:1,
        sn:selectedRowKey.value=='all'?[]:selectedRowKey.value,
        batch_id:batchData.value.id,
        new_batch_id:data.id,
        product_id:data.product_id,
        product_sku_sn:data.product_sku_sn
      }
      let result=await changeWarehousingBatch(json).then(res=>res.data).catch(error=>error)
      if(iscode(result,true)){
        emit('success')
      }
    };

    return {
      batchSelect,
      batchData,
      activeKey,
      ...tableHoosks,
      columns,
      editBatchSelect,
      rowSelection,
      allBatch,
      someBatch
    };
  },
};
</script>